/* eslint-disable camelcase */
import axios from 'axios';
import { POSSIBLE_FORMS } from '../default/signUp/sign.up.memo.form';
// import { COUNTRY_LANGUAGE_LIST } from './webSiteLanguages';

const CAREERS_URL = `${process.env.GATSBY_CAREERS_API_URL}/${process.env.GATSBY_CAREERS_API_VERSION}/`;
const WEBAPP_URL = `${process.env.GATSBY_WEBAPP_API_URL}/${process.env.GATSBY_WEBAPP_API_VERSION}/`;
const WEBAPP_URL_NG = `${process.env.GATSBY_WEBAPP_API_URL_OLD}/`;
const GEOLOC_API = `${process.env.GATSBY_GEOLOC_API}/`;
const APP_NAME = process.env.AUTH_APP_NAME;
const INVESTOR_APP_NAME = process.env.AUTH_INVESTOR_APP_NAME;
const openingsGrouped = { data: null };
const openings = { data: null };
const categories = { data: null };
const locations = { data: null };
const cities = { data: null };
const universities = { data: null };

const EMAILS_ERRORS = {
  OLD: 'already exists',
  NEW: 'ALREADY_EXISTS',
};

const DEFAULT_REFERRAL = 'Direct';
const DEFAULT_EPI = null;

const capitalize = (s) => {
  if (typeof s !== 'string') return undefined;
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
};
const getUtmSourceAndClean = () => {
  const utmSourse = sessionStorage.getItem('utmSource');
  sessionStorage.removeItem('utmSource');
  const sourceToReturn = utmSourse && utmSourse.replace(/\s/g, '').length ? capitalize(utmSourse) : DEFAULT_REFERRAL;
  return sourceToReturn;
};

const getEpiAndClean = () => {
  const epi = sessionStorage.getItem('epi');
  sessionStorage.removeItem('epi');
  return epi || DEFAULT_EPI;
};

const getUtmMediumAndClean = () => {
  const utmMedium = sessionStorage.getItem('utmMedium');
  sessionStorage.removeItem('utmMedium');
  return capitalize(utmMedium);
};

export const requests = {
  getOpeningsGrouped: async () => {
    const endpoint = 'openings/countries';
    const response = openingsGrouped.data
      ? openingsGrouped
      : await axios({
        url: CAREERS_URL + endpoint,
        method: 'get',
      });
    const { data } = response;
    openingsGrouped.data = data;
    return data;
  },
  getOpenings: async ({ limit, orderBy }) => {
    const endpoint = 'openings/';
    const response = openings.data
      ? openings
      : await axios({
        url: CAREERS_URL + endpoint,
        method: 'get',
        params: {
          limit,
          orderBy,
        },
      });
    const { data } = response;
    openings.data = data;
    return data;
  },
  getOpeningsByCountry: async ({ country, orderBy }) => {
    const endpoint = `openings/countries/${country}`;
    const response = await axios({
      url: CAREERS_URL + endpoint,
      method: 'get',
      params: {
        select: 'cat,code,country,created_at,title,city',
        orderBy,
      },
    });
    const { data } = response;
    return data;
  },
  getCategories: async () => {
    const endpoint = 'openings/categories/';
    const response = categories.data
      ? categories
      : await axios({
        url: CAREERS_URL + endpoint,
        method: 'get',
      });
    const { data } = response;
    categories.data = data;
    return data;
  },
  getLocationsList: async () => {
    const endpoint = 'locations/';
    const response = locations.data
      ? locations
      : await axios({
        url: CAREERS_URL + endpoint,
        method: 'get',
      });
    const { data } = response;
    locations.data = data;
    return data;
  },
  getCities: async (country) => {
    const endpoint = `locations/${country}/cities`;
    const response = cities[country]
      ? cities[country]
      : await axios({
        url: CAREERS_URL + endpoint,
        method: 'get',
      });
    const { data } = response;
    cities[country] = {
      data,
    };
    return data;
  },
  getInstituitions: async (country) => {
    const endpoint = `locations/${country}/universities`;
    const response = universities[country]
      ? universities[country]
      : await axios({
        url: CAREERS_URL + endpoint,
        method: 'get',
      });
    const { data } = response;
    universities[country] = {
      data,
    };
    return data;
  },
  sendApplication: async (params, file) => {
    const endpoint = 'applications/';
    const formData = new FormData();
    Object.keys(params).forEach((key) => {
      formData.append(key, params[key]);
    });
    formData.append('cv', file);
    const response = await axios({
      method: 'post',
      url: CAREERS_URL + endpoint,
      config: { headers: { 'Content-Type': 'multipart/form-data' } },
      data: formData,
    });
    return response.status === 200;
  },
  sendRegisterRequest: async (params) => {
    const { register_in_sardis: registerInSardis } = params;
    const isInvestor = params.signupType === POSSIBLE_FORMS.INVESTORS;
    const webAppUrl = !registerInSardis ? WEBAPP_URL_NG : WEBAPP_URL;
    const appName = isInvestor ? INVESTOR_APP_NAME : APP_NAME;
    const endpoint = !registerInSardis ? 'user/signup/' : 'Users/';
    const referral = getUtmSourceAndClean();
    const referral_client_id = getEpiAndClean();
    const referral_sub_channel = getUtmMediumAndClean();
    const response = await axios({
      method: 'post',
      url: `${webAppUrl + endpoint}`,
      data: {
        ...params, referral, referral_client_id, referral_sub_channel,
      },
      headers: {
        application: appName,
      },
    }).catch((resp) => resp.response);

    const values = {
      status: true,
      emailExists: false,
    };

    if (response && response.status >= 400) {
      if (!registerInSardis) {
        values.emailExists = response.data && response.data.error && response.data.error.message ? response.data.error.message.includes(EMAILS_ERRORS.OLD) : false;
        values.status = values.emailExists;
      } else {
        values.emailExists = response.data && response.data[0] && response.data[0].error ? response.data[0].error.includes(EMAILS_ERRORS.NEW) : false;
        values.status = values.emailExists;
      }
    }
    return values;
  },
  getLocFromService: async () => {
    const response = await axios.get(`${GEOLOC_API}country/`).catch((error) => false);
    return response.data ? response.data.toLowerCase() : false;
  },
  sendLandingLead: async (params) => {
    const webAppUrl = WEBAPP_URL;
    const endpoint = 'Users/';
    const response = await axios({
      method: 'post',
      url: webAppUrl + endpoint,
      data: params,
      headers: {
        application: APP_NAME,
      },
    }).catch((resp) => resp.response);
    const error = response.data && response.data[0] && response.data[0].error ? response.data[0].error : false;
    const status = error.toString() === 'ALREADY_EXISTS';
    const emailExists = error.toString() === 'ALREADY_EXISTS';
    const values = {
      status: error ? status : true,
      emailExists,
    };
    return values;
  },
};

export default requests;
